import styled from 'styled-components';

const ActionsRow = styled.div`
  display: flex;
  gap: 10px;
`;

export default ActionsRow;
